import { Box, Divider } from '@wix/design-system';
import {
  getSearchParams,
  GtmEvents,
  PackagePickerSteps,
  useGtmLogger,
  wixServerData,
} from '@wix/package-picker-shared';
import {
  PageDisclaimer,
  StudioCta,
  TrustBuilders,
  useInitSelectCyclePageBiEvents,
  useStudioPanorama,
  useViewChange,
} from '@wix/package-picker-shared-studio';
import React from 'react';
import { CycleSelector, PageLayout } from '../../components';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';

export const SelectCyclePage = () => {
  const handleViewChange = useViewChange();
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const selectedCycleId =
    StudioPackagePickerModule.SDK.PackagePickerStore.useSelectedCycleId();
  useGtmLogger(GtmEvents.SELECT_CYCLE);
  const { didInit } = useInitSelectCyclePageBiEvents();
  const panorama = useStudioPanorama();

  const { siteGuid } = getSearchParams();
  const { siteAuthorizationType } = wixServerData.get();
  const { showNotification } = StudioPackagePickerModule.SDK.useNotification();
  const { bi } = StudioPackagePickerModule.internals;

  React.useEffect(() => {
    if (!didInit) {
      panorama.startTransaction('select-cycle-page-load');
    } else {
      bi.onSelectCyclePageLoad?.({});
      panorama.finishTransaction('select-cycle-page-load');
    }
  }, [didInit]);

  const handleContinueToCheckout = () => {
    bi.onContinueToCheckoutClick?.({});

    if (siteAuthorizationType === 'unauthorized' && siteGuid) {
      const messageKey = 'app.notification.initialization_permissions_error';
      showNotification({
        message: t(messageKey),
        onShow: () => {
          bi.onNotificationShow?.({
            messageKey,
            step: 'select-cycle',
          });
        },
        onCloseClick: () => {
          bi.onNotificationClose?.({});
        },
      });

      return;
    }

    if (!siteGuid) {
      StudioPackagePickerModule.internals.modalsController.NoSitesModal.show(
        {},
      );
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
    handleViewChange(PackagePickerSteps.CHECKOUT, { cycleId: selectedCycleId });
  };

  const handleBack = () => {
    bi.onBackButtonClick?.({
      fromStep: 'select-cycle',
    });
    handleViewChange(PackagePickerSteps.SELECT_PLAN, { cycleId: null });
  };

  return (
    <PageLayout
      onBack={handleBack}
      backButtonText={t('Advanced.Plans_Steps_Step1')}
    >
      <Box
        width="662px"
        direction="vertical"
        margin="SP7 SP3 SP5 SP3"
        gap="SP5"
      >
        <CycleSelector />
        <Box align="right" width="100%">
          <Box>
            <StudioCta onClick={handleContinueToCheckout} filled size="medium">
              {t('subscription_btn.continue_to_checkout')}
            </StudioCta>
          </Box>
        </Box>
      </Box>
      <Box direction="vertical" gap="SP5" margin="0 SP2">
        <PageDisclaimer />
        <Divider />
        <TrustBuilders />
      </Box>
    </PageLayout>
  );
};
